<template>
  <div
    class="modal"
    :class="{ 'is-active': value }">

    <div class="modal-background"
      @click="close()">
    </div>
    
    <div class="modal-content">
      <div class="modal-card">

        <header class="modal-card-head">
          <p class="modal-card-title">Transfer Inventory to a Project</p>
          <button
            class="delete"
            aria-label="close"
            @click="close(true)">
          </button>
        </header>

        <v-form class="modal-card-body" :valid.sync="valid">

          <div class="field">
            <label class="label">Project*</label>
            <v-select
              required
              :options="projects"
              item-text="project_name"
              item-value="id"
              v-model="toProjectId"
            />
          </div>

          <div class="field">
            <label class="label">Product Being Transferred</label>
            <span>{{ product.name }}</span>
          </div>
          
          <div class="field">
            <label class="label">Quantity Available</label>
            <span>{{ qtyAvailable -  qty}}</span>
          </div>

          <div class="field">
            <label class="label">Transfer Quantity*</label>
            <v-text-field
              required
              placeholder="Enter Transfer Quantity"
              type="number"
              :rules="transferQtyRules"
              v-model="qty">
            </v-text-field>
          </div>

        </v-form>

        <footer class="modal-card-foot">
          <button 
            :disabled="!valid"
            class="button is-primary" 
            @click.stop="transfer()">
            Confirm Transfer
          </button>
          <button 
            class="button" 
            @click.stop="close(true)">
            Cancel
          </button>
        </footer>

      </div>
    </div>

  </div>
</template>

<script>
import VForm from '@/components/base/VForm'
import VTextField from '@/components/base/VTextField'
import VSelect from '@/components/base/VSelect'

import { mapState, mapActions } from 'vuex'

export default {
  props: {
    value: {
      type: Boolean
    },
    productInventory: {
      type: Object
    }
  },
  components: { 
    VForm,
    VTextField,
    VSelect
  },
  data() {
    return {
      toProjectId: null,
      qty: 0,
      valid: false
    }
  },
  computed: {
    ...mapState("projects", ["projects"]),
    product() {
      return this.productInventory.product_master;
    },
    qtyAvailable() {
      return this.productInventory.qty_available;
    },
    transferQtyRules() {
      return [
        (v) => v <= this.qtyAvailable || 'Transfer quantity cannot be greater than quantity available'
      ]
    }
  },
  created() {
    this.initialize();
  },
  methods: {
    ...mapActions("projects", ["getProjects"]),
    ...mapActions("inventoryCentral", ["transferToProject"]),
    initialize() {
      if (this.projects.length == 0) {
        this.getProjects({ per_page: 1000 });
      }
    },
    transfer() {
      this.transferToProject({
        to_project_id: this.toProjectId,
        stocking_unit_id: this.productInventory.stocking_unit_id,
        qty: this.qty
      }).then(() => this.close(true))
    },
    close(clear=false) {
      this.$emit('input', false);
      if (clear) {
        this.clearData();
      }
    },
    clearData() {
      Object.assign(this.$data, this.$options.data.call(this));
    }
  }
}
</script>
